// ACTIONS
export const QUEUES_GET_ALL = 'QUEUES_GET_ALL';
export const QUEUES_GET_ALL_SUCCEEDED = 'QUEUES_GET_ALL_SUCCEEDED';
export const QUEUES_GET_ALL_FAILED = 'QUEUES_GET_ALL_FAILED';
